// quoteFiles.ts — 견적 도면·첨부파일 순수 로직 (검증/표시 포맷).
// 화면(NewQuoteScreen)에는 계산 로직을 두지 않는다.
// 정책은 백엔드 api/models/quote.py 의 MAX_FILE_BYTES/ALLOWED_FILE_EXTENSIONS 와 동기.

export interface QuoteAttachment {
  key: string; // S3 오브젝트 키 — quotes/<uuid>/<filename>
  name: string; // 원본 파일명 (표시용)
  size: number; // bytes
}

export const MAX_QUOTE_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_QUOTE_FILES = 5;

const ALLOWED_FILE_EXTENSIONS = new Set([
  // 도면(PDF/CAD)
  ".pdf",
  ".dwg",
  ".dxf",
  ".dwf",
  ".step",
  ".stp",
  ".igs",
  ".iges",
  // 사진
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
]);

const extension = (name: string): string => {
  const dot = name.lastIndexOf(".");
  return dot < 0 ? "" : name.slice(dot).toLowerCase();
};

/** 첨부 파일 검증 — 통과 시 null, 실패 시 토스트 메시지. currentCount 는 이미 첨부된 개수. */
export function validateQuoteFile(
  file: { name: string; size: number },
  currentCount: number
): string | null {
  if (currentCount >= MAX_QUOTE_FILES)
    return `첨부파일은 최대 ${MAX_QUOTE_FILES}개까지 첨부할 수 있습니다`;
  if (!ALLOWED_FILE_EXTENSIONS.has(extension(file.name)))
    return "PDF/CAD/이미지 파일만 첨부할 수 있습니다";
  if (file.size > MAX_QUOTE_FILE_BYTES) return "파일은 10MB 이하만 첨부할 수 있습니다";
  return null;
}

/** 파일 크기 표시 — "512 B" / "2.0 KB" / "1.8 MB". */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
